
import * as angular from "angular";

export class NotifyFactory {

    constructor($rootScope: angular.IRootScopeService) {

        return {

            subscribe: (scope, callback) => {
                var handler = $rootScope.$on("notifying-service-event", callback);
                scope.$on("$destroy", handler);
            },

            notify: () => {
                $rootScope.$emit("notifying-service-event");
            }
        }
    }
}

// How to Use:
//this._notifyFactory.subscribe(this._scope, () => { console.log("notified"); });
//this._notifyFactory.notify();
